"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyRandom = exports.StrategyTheta = exports.Strategy = void 0;
const tf = __importStar(require("@tensorflow/tfjs-core"));
//import {Tensor } from "@tensorflow/tfjs";
const tools_1 = require("./tools");
class Strategy {
    constructor(student) {
        this.student = student;
    }
    update(objective, activity, answer, date) {
        // Update counters, then timers
        // Important!!! Need to calculate the recall probability before resetting the timer
        this.student.adjust_counters(objective, activity, answer, date);
        // reset ref_date only if response is correct
        if (Number(answer) == 1) {
            this.student.reset_ref_date(objective, activity, date);
        }
    }
    select_activity(interval_softmax, date = new Date(), theta = 0.4) {
        return ['', ''];
    }
    select_activity_ob(objective, date = new Date(), theta = 0.4) {
        return ['', ''];
    }
}
exports.Strategy = Strategy;
class StrategyTheta extends Strategy {
    constructor(student) {
        super(student);
    }
    /*
     * Generate an activity according to the theta threshold policy (the recall probability close to theta)
     * @param interval_softmax Number of activities in the interval of softmax (default: 5)
     * @param theta Theta threshold value (default: 0.4)
     * @returns A tuple containing the selected objective and activity
     */
    select_activity(interval_softmax = 5, date = new Date(), theta = 0.4) {
        // Avoiding the problem of small review space
        //the minmum of "interval_softmax" and half of the "number of activities in review space" 
        interval_softmax = Math.min(interval_softmax, Math.floor(Object.keys(this.student.dict_idx_ob_act()).length / 2));
        // Transform to 1D array for sorting  
        var list_prob = this.student.generate_prob(date).reduce((result, current) => result.concat(current), []);
        // The absolute values of the differences between probabilities and theta
        const prob_theta_diff = list_prob.map((prob) => Math.abs(prob - theta));
        // The indices of top n activities close to theta, where n = floor(interval_softmax/2) (at least 1)
        const candidates = prob_theta_diff
            .map((_, index) => index)
            .sort((a, b) => prob_theta_diff[a] - prob_theta_diff[b]) //sort by value
            .slice(0, Math.max(1, interval_softmax));
        //console.log(candidates.map((id) => this.student.dict_idx_ob_act().get(id)));
        //console.log("original:", candidates.map((id) => list_prob[id]));
        //console.log("diff:", candidates.map((id) => prob_theta_diff[id]));
        //console.log(this.student.generate_prob());
        //console.log("\n");
        // Use softmax to randomly generate one of the activities in order to avoid repetition of the same activities
        const ProbabilitiesInverse = candidates.map((index) => prob_theta_diff[index]).map((x) => 1 / x);
        const softmaxProbabilitiesInverse = tf.softmax(tf.tensor1d(ProbabilitiesInverse)).arraySync();
        const idx = candidates[(0, tools_1.randomChoice)(softmaxProbabilitiesInverse)];
        // Review activity
        const [ob, act] = this.student.dict_idx_ob_act()[idx];
        return [ob, act];
    }
    /**
     * Generate an activity of a specific objective "ob" according to the theta threshold policy (the recall probability close to theta)
     * @param ob The objective for which to select the activity
     * @param theta Theta threshold value (default: 0.4)
     * @returns A tuple containing the selected objective and activity
     */
    select_activity_ob(objective, date = new Date(), theta = 0.4) {
        // Recall probabilities of each activity in the objective "ob"
        let ob_id = this.student.objectives.indexOf(objective);
        const list_prob_ob = this.student.generate_prob(date)[ob_id];
        // The absolute values of the differences between probabilities and theta
        const prob_theta_diff = list_prob_ob.map((prob) => Math.abs(prob - theta));
        // The indices of top n activities close to theta where n = floor(nbr_activities/2), at least 1
        const candidates = prob_theta_diff
            .map((diff, idx) => ({ diff, idx }))
            .sort((a, b) => a.diff - b.diff)
            .slice(0, Math.max(1, Math.ceil(list_prob_ob.length / 2)))
            .map((item) => item.idx);
        // Use softmax to randomly generate one of the activities in order to avoid repetition of the same activities
        //act = np.random.choice(candidates, 1, p=softmax(1/prob_theta_diff[candidates]))[0]
        //idx = np.random.choice(candidates, 1, p=softmax(1/prob_theta_diff[candidates]))[0]
        const ProbabilitiesInverse = candidates.map((index) => prob_theta_diff[index]).map((x) => 1 / x);
        const softmaxProbabilitiesInverse = tf.softmax(tf.tensor1d(ProbabilitiesInverse)).arraySync();
        const idx = candidates[(0, tools_1.randomChoice)(softmaxProbabilitiesInverse)];
        const activity = this.student.activities[objective][idx];
        return [objective, activity];
    }
}
exports.StrategyTheta = StrategyTheta;
class StrategyRandom extends Strategy {
    constructor(student) {
        super(student);
    }
    /**
     * Generate an activity according to the theta threshold policy (the recall probability close to theta)
     * @param interval_softmax Number of activities in the interval of softmax
     * @returns A tuple containing the selected objective and activity
     */
    select_activity(interval_softmax) {
        const ob = this.student.objectives[Math.floor(Math.random() * this.student.objectives.length)];
        const act = this.student.activities[ob][Math.floor(Math.random() * this.student.activities[ob].length)];
        return [ob, act];
    }
    /**
     * Generate an activity of a specific objective "ob" according to the theta threshold policy (the recall probability close to theta)
     * @param ob The objective for which to select the activity
     * @returns A tuple containing the selected objective and activity
     */
    select_activity_ob(objective) {
        const activity = this.student.activities[objective][Math.floor(Math.random() * this.student.activities[objective].length)];
        return [objective, activity];
    }
}
exports.StrategyRandom = StrategyRandom;
